import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";
import { CLEAR_CACHE_REQUEST } from "./graphql";

const clearCache = async () => {
  const response = await client.query({
    query: CLEAR_CACHE_REQUEST,
    fetchPolicy: "network-only",
  });
  const results = await getGraphqlResult(response, "clearCache");
  return results;
};

export {
  clearCache,
};
